const { VUE_APP_GOOGLE_MAPS_API_KEY } = process.env

export default {
  data: () => ({
    mapsApiLoaded: false,
    mapsApiLoadingFailed: false
  }),
  mounted() {
    this.importMapsApi()
  },
  methods: {
    importMapsApi() {
      const key = VUE_APP_GOOGLE_MAPS_API_KEY

      this.$loadScript(
        `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places`
      )
        .then(() => {
          this.mapsApiLoaded = true
          this.mapsApiLoadingFailed = false
        })
        .catch(() => {
          // Failed to fetch script
          this.mapsApiLoaded = false
          this.mapsApiLoadingFailed = true
        })
    }
  }
}
